import { render, staticRenderFns } from "./busqueda.vue?vue&type=template&id=36fdbe95&scoped=true"
import script from "./busqueda.vue?vue&type=script&lang=js"
export * from "./busqueda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fdbe95",
  null
  
)

export default component.exports